import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import SubgroupFormFields from "./SubgroupFormFields.js";


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            padre_id: null,
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
        buttonClass: PropTypes.string
    }

    setSelects(data) {
        this.setState({
            padre_id: data.padre_id,
        });
    }

    ResetForm() {
        this.setState({
            padre_id: null,
        });
    }


    render() {
        return (
            <ParadigmaModal
                getUrl={api.usuarios.subgrupos.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Subgrupo"}
                buttonTitle={"Ver Subgrupo"}
                buttonIcon={"fa fa-search fa-lg"}

                saveButton={false}
                closeButton={true}
                buttonClass={this.props.buttonClass}
                className={"ui-modal-dialog ui-modal-md"}

                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.ResetForm()}
            >
                <div className="ui-form">
                    <SubgroupFormFields
                        disabled={true}
                        grupoFieldName={""}
                        padreId={this.state.padre_id}
                        onGrupoChange={(data) => this.setState({ padre_id: (data != null ? data.pk : 0) })} />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Subgrupos/Detail.js